import React from 'react';
import { Box, Button, Typography, CircularProgress, Container, DialogTitle, Dialog, DialogContent } from '@mui/material';
import { t } from 'i18next';

import useScholarshipData from '../acceptDecline/useScholarshipData';
import RenderIf from '../../renderIf/RenderIf';
import { ScholarshipTables } from '../acceptDecline/choice/Choice';

const ScholarshipData = ({ open, handleClose, appInstId, status, ...restOfProps }) => {
    const { scholarshipData, retrieveScholarshipData } = useScholarshipData(appInstId, status);

    React.useEffect(() => {
        if (open) {
            retrieveScholarshipData();
        }
    }, [open]);

    return (
        <Dialog open={open}>
            <DialogTitle>Scholarship details</DialogTitle>
            <DialogContent>
                <Box
                    sx={{
                        '& p.MuiTypography-root': {
                            color: (theme) => theme.palette.grey.header,
                        },
                    }}
                >
                    <RenderIf isTrue={!scholarshipData.Loading}>
                        <Typography>{t('AcceptDecline.AcceptedCalculation')}</Typography>

                        <ScholarshipTables scholarshipData={scholarshipData}></ScholarshipTables>
                    </RenderIf>

                    <RenderIf isTrue={scholarshipData.Loading}>
                        <Container
                            sx={{
                                height: 100,
                            }}
                        >
                            <CircularProgress /> <Typography component="span">Retrieving scholarship data...</Typography>
                        </Container>
                    </RenderIf>
                </Box>

                <Box>
                    <Button
                        onClick={() => handleClose?.()}
                        variant="contained"
                        disabled={scholarshipData.Loading}
                    >
                        Close
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default ScholarshipData;
